<script lang="ts">
	import LogoTenant from '$lib/components/logo/LogoTenant.svelte'
	import { Theme } from '$lib/components/theme'
	import { tenantImages } from '@store/tenantImages'
	import { currentTheme } from '@store/theme'
	import { webName } from '@store/webName'

	interface Props {
		center?: boolean
		forceLightMode?: boolean
	}

	let { center = false, forceLightMode = false }: Props = $props()

	let imageUrl: string = $derived(
		$currentTheme === Theme.dark && !forceLightMode
			? $tenantImages.darkModeLogo || $tenantImages.lightModeLogo
			: $tenantImages.lightModeLogo || $tenantImages.darkModeLogo,
	)
</script>

{#if $tenantImages.darkModeLogo || $tenantImages.lightModeLogo}
	<div class="flex h-[34px] w-full items-center {center ? 'm-auto justify-center' : ''}">
		<img class="h-full object-contain" alt={$webName} src={imageUrl} />
	</div>
{:else}
	<LogoTenant name={$webName.slice(0, 10)} center />
{/if}
